import { HttpClient } from '@angular/common/http';
import { Component, inject, Injector } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { COMMON_MODULES, IMAGES_URL, ALL_SERVICES, LOGIN_PATH, CEHAS_ACCESS_ACCOUNT, PLUS_MEMBERSHIP, TRU_ACCESS_ACCOUNT } from '@src/app/core/constants';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import { MiniEnvTabsComponent } from "@src/app/core/shared/components/mini-env/mini-env-tabs/mini-env-tabs.component";
import { HelperService } from '@src/app/core/services';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-tru',
  imports: [...COMMON_MODULES,
    HeadingBlockOneModule,
    IconboxOneModule,
    IconboxTwoModule,
    HeadingBlockFullWidthModule,
    ImageboxOneModule,
    ImageboxFullwidthModule,
    CardboxOneModule,
    BannerOneModule,
    ImageboxBulletScrollComponent,
    MiniEnvHeadingBlockComponent,
    MiniEnvFaqsComponent,
    MiniEnvBannerComponent,
    MembershipPlanModule,
    VideoPlayerComponent,
    MiniEnvContentBoxComponent, MiniEnvTabsComponent],
  templateUrl: './tru.component.html',
  styleUrl: './tru.component.scss'
})
export class TruComponent extends CoreClass {
IMAGES_URL: string = IMAGES_URL;
  faqList = [];
  imgSrc = `assets/tenant-assets/mini-env/images/father-child-forest.png`;
  imgSrcMob = `assets/tenant-assets/mini-env/images/father-child-forest-responsive.png`;
  imgLink = `assets/tenant-assets/mini-env/images/woman-waving-sm.png`;

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  serviceDetails: any;
  services = ['tru_essentials', 'tru_elite'];
  helper = inject(HelperService);


  benefits = [
    {
      id: '01',
      title: 'Flexibility',
      description: 'Manage your health with comprehensive in-person and virtual care options that fit your schedule and medical needs.',
      bgImage: 'd-shape'
    },
    {
      id: '02',
      title: 'Affordability',
      description: 'Free virtual services, and direct-pay for in-person care with exclusive discounts, so you pay less than with an insurance plan.',
      bgImage: 'circles'
    },
    {
      id: '03',
      title: 'Transparency',
      description: 'Know the total cost of care when you make an appointment, and pay at the time of service. Goodbye surprises & bills in the mail.',
      bgImage: 'm-shape'
    },
  ];

  faqs: any[] = [
  {
    question: 'What is the difference between WoW Plus & health insurance?',
    answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
  },
  {
    question: 'Why do I need WoW Health?',
    answer: 'It provides affordable access to routine care and prescriptions...'
  }
];

bannerSlides: any[] = [
  {
    title: 'Your Partner in Health, Always Within Your Reach',
    subtitle: 'Get free and unlimited virtual care and generic medications, with discounted in-person care like office visits, labs, imaging, dental, and vision.',
    link: '/join',
    buttonText: 'Member Login',
    buttonText2: 'First Time Login',
    buttonAction: 'login',
    buttonAction2: 'first-login',
    bannerClass: 'tru-banner'
  },
];

 steps = [
    {
      id: '01',
      title: '01. Log In to Your Account',
      description: 'Login to your account'
    },
    {
      id: '02',
      title: '02. View Your Dashboard',
      description: 'Your dashboard lists all of your available services'
    },
    {
      id: '03',
      title: '03. Choose Your Service',
      description: 'Select the needed services and follow the workflow.'
    },
  ];

  ngOnInit(): void {
    this.helper.changeMiniEnvColor();

   this.getService();
   this.getFAQs();
  }

  async getService() {
    try {
      const services = await this.sharedService.getServicesForTabs(); 
      this.serviceDetails = services.find((s: any) => s.serviceCode === 'telehealth_services');
    } catch (error) {
      console.error('Error fetching services for tabs:', error);
    }
  }

  getFAQs() {
    const apiUrl = `/assets/i18n/mini-env/tru/${this.sharedService.currentLanguage}.json`;
    this.httpClient.get(apiUrl).subscribe((json: any) => 
      {
        console.log(json)
      this.faqList = json.FAQS.FAQ_LIST;
    });
  }

  login() {
    this.router.navigate([LOGIN_PATH]);
  }

  onSliderBtnAction(action: any) {
    if (action == 'login') {
      this.login();
    } else {
      this.router.navigate([TRU_ACCESS_ACCOUNT]);
    }
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }
}
